(function () {
    /**
     * Open / Close Responsive menu
     */
    const openOrCloseMenu = function (event) {
        const respMenuBtn = document.getElementsByClassName(
            's-resp-menu-trigger',
        )[0];
        const respMenu =
            document.getElementsByClassName('s-main-navigation')[0];
        const isClickOnTrigger = respMenuBtn.contains(event.target);
        const respMenuIsOpen = respMenu.classList.contains('s-resp-menu-open');

        respMenu.classList.toggle(
            's-resp-menu-open',
            isClickOnTrigger && !respMenuIsOpen,
        );
        respMenuBtn.classList.toggle(
            's-resp-menu-open',
            isClickOnTrigger && !respMenuIsOpen,
        );
    };
    document.addEventListener('click', openOrCloseMenu);
})();
